var _circle, _path, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAttentionRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 21,
    fill: "#F50404"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4414 11.5624C18.4054 10.9867 18.8626 10.5 19.4395 10.5H22.5605C23.1374 10.5 23.5946 10.9867 23.5586 11.5624L22.8086 23.5624C22.7757 24.0894 22.3386 24.5 21.8105 24.5H20.1895C19.6614 24.5 19.2243 24.0894 19.1914 23.5624L18.4414 11.5624Z",
    fill: "#FDFDFD"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 28.875,
    r: 2.625,
    fill: "#FDFDFD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttentionRed);
export default __webpack_public_path__ + "static/media/AttentionRed.ede7820826f003e53a7f6225c2cc9f5f.svg";
export { ForwardRef as ReactComponent };